import React from 'react'
import { CloudUploadOutlined } from '@ant-design/icons';
import editButton from '../../../assets/images/new-dashboard/edit.svg';
import { EditOrganisationSectionTwoProps } from './types/EditOrganisationTypes';

const EditOrganisationSectionTwo = (props: EditOrganisationSectionTwoProps) => {
  const { selectedImage, handleImageUpload } = props

  return (
    <div className='flex flex-col '>
      <div className='organisation_logo flex flex-col items-center'>
        <h4 className='m-0 mb-1'>Upload Logo</h4>
        <div className='file-upload relative !m-0'>
          <div className='file-upload-inner relative flex items-center justify-center'>
            <input type='file' accept='image/*' className='absolute' onChange={handleImageUpload} />
            {selectedImage && <img src={selectedImage} alt="Selected" className='sign-uploaded' />}
            {!selectedImage && (
              <span className='material-symbols-outlined cloud'>
                {' '}
                <CloudUploadOutlined />
              </span>
            )}
          </div>
          <span className='material-symbols-outlined edit absolute'>
            <img src={editButton} alt='Edit' className='cursor-pointer' />
          </span>
        </div>
      </div>
    </div>
  )
}

export default EditOrganisationSectionTwo
